import type Result from './Result'

import { LoadedRole } from '../../../Foobara/Auth/Types/Role/Loaded'

import { LoadedPersistedType } from '../../../Foobara/Autocrud/Types/PersistedType/Loaded'

import { DomainAggregate } from '../../../Foobara/Commandforge/Types/Domain/Aggregate'

import { LoadedDynamicCommand } from '../../../Foobara/Commandforge/Types/DynamicCommand/Loaded'

import { LoadedOrganization } from '../../../Foobara/Commandforge/Types/Organization/Loaded'

import { UserAggregate } from '../../../Foobara/Commandforge/Types/User/Aggregate'

export default function castJsonResult (json: any): Result {
  json.owned_organizations?.forEach((element: any, index: number, array: any[]) => {
    array[index] = new LoadedOrganization(element)
  })
  json.member_of_organizations?.forEach((element: any, index: number, array: any[]) => {
    array[index] = new LoadedOrganization(element)
  })
  json.owned_domains?.forEach((element: any, index: number, array: any[]) => {
    element.persisted_types?.forEach((element: any, index: number, array: any[]) => {
      array[index] = new LoadedPersistedType(element)
    })
    element.persisted_commands?.forEach((element: any, index: number, array: any[]) => {
      array[index] = new LoadedDynamicCommand(element)
    })
    array[index] = new DomainAggregate(element)
  })
  json.member_of_domains?.forEach((element: any, index: number, array: any[]) => {
    element.persisted_types?.forEach((element: any, index: number, array: any[]) => {
      array[index] = new LoadedPersistedType(element)
    })
    element.persisted_commands?.forEach((element: any, index: number, array: any[]) => {
      array[index] = new LoadedDynamicCommand(element)
    })
    array[index] = new DomainAggregate(element)
  })
  json.roles?.forEach((element: any, index: number, array: any[]) => {
    array[index] = new LoadedRole(element)
  })
  json = new UserAggregate(json)
  return json
}
